import { MatFormFieldDefaultOptions } from '@angular/material/form-field';

export const materialFieldDefaults: MatFormFieldDefaultOptions = {
  appearance: 'fill'
};
